export default class PairingCodeService {
	constructor(apiService) {
		this.apiService = apiService
	}

	createEntity(params) {
		return this.apiService.callPost('pairing_codes', params)
	}

	deletePairingCode(id) {
		return this.apiService.callDelete('pairing_codes/' + id)
	}
}



// WEBPACK FOOTER //
// ./src/service/PairingCodeService.js